import { render } from "./LHCourseTrainers.vue?vue&type=template&id=03acd327"
import script from "./LHCourseTrainers.vue?vue&type=script&lang=js"
export * from "./LHCourseTrainers.vue?vue&type=script&lang=js"

import "./LHCourseTrainers.vue?vue&type=style&index=0&id=03acd327&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__